export default __webpack_public_path__ + "static/media/checked.0ba0e584.svg";